export default "__VITE_ASSET__8cca0dd8__"